const appID = "566"; // real = 249

const useEmploymentContractCreate = () => {
  return { appID };
};

export type Props = ReturnType<typeof useEmploymentContractCreate>;

export default useEmploymentContractCreate;
